import { Header } from "../component/home/Header";
import { Footer } from "../component/home/Footer";
// import { ChatbotWidget } from "../component/home/ChatbotWidget";
import { Hero } from "../component/about-us/Hero";
import { CategoryCards } from "../component/about-us/CategoryCards";
import { HowItWorks } from "../component/about-us/HowItWorks";
import { WhyChooseUs } from "../component/about-us/WhyChooseUs";
import { SecuritySection } from "../component/about-us/SecuritySection";
import { CtaBanner } from "../component/about-us/CtaBanner";

export function AboutUsPage() {
  return (
    <div className="min-h-screen w-full bg-white">
      <Header />

      <main>
        <Hero />
        <CategoryCards />
        <HowItWorks />
        <WhyChooseUs />
        <SecuritySection />
        <CtaBanner />
      </main>

      <Footer />
      {/* <ChatbotWidget /> */}
    </div>
  );
}
